import { useLocation } from "react-router-dom";
import { getSchemasForRoute } from "@/seo/schema";

export default function SeoSchema() {
  const { pathname } = useLocation();
  const schemas = getSchemasForRoute(pathname);

  return (
    <>
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}